import { Component,  OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-inventory",
  templateUrl: "./inventory.component.html",
  styleUrls: ["./inventory.component.css"]
})
export class InventoryComponent implements OnInit {
  allPlans:any=[];
  form: FormGroup; 
  amount:any;
  clicks:any;
  planId:any;
  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService,private formBuilder: FormBuilder) { 
    this.form = this.formBuilder.group({
    })
  }

  ngOnInit(): void {
    this.getPlans()
    
  }
 getPlans(){
  let params = new HttpParams(); 
  params = params.append("planType", "1");
  this.api.getData(apiUrl._paymentPlan,params)
  .subscribe(async (res) => {
    this.allPlans = res.data.data; 
    console.log(this.allPlans,'this.allPlans');
    
  })
 }
onChange(event){
  this.planId= event.target.value;
  this.allPlans.map((amt)=>{
    if(amt.id == event.target.value){
      this.amount = amt.planAmount;
      this.clicks = amt.numberOfClicks;
    }
    
  })
}
//  submit
redirectTo(){
  // this.router.navigateByUrl(`/checkout/${this.planId}`);
  this.router.navigateByUrl(`/address/${this.planId}`);
}
}
